import { __assign, __rest } from "tslib";
import React from 'react';
import { Paper as MaterialPaper, makeStyles, } from '@material-ui/core';
var usePaperStyles = function (_a) {
    var isHovered = _a.isHovered, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor;
    return makeStyles({
        root: __assign(__assign({}, (backgroundColor ? { backgroundColor: backgroundColor } : {})), (borderColor ? { border: "1px solid " + borderColor } : {})),
        elevation1: {
            boxShadow: function () {
                return isHovered
                    ? '0px 6px 10px 2px rgba(0,0,0,0.08)'
                    : '0px 2px 4px 0px rgba(0,0,0,0.08)';
            },
        },
    });
};
export var Paper = React.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.isHovered, isHovered = _b === void 0 ? false : _b, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, props = __rest(_a, ["children", "isHovered", "backgroundColor", "borderColor"]);
    var styles = usePaperStyles({ isHovered: isHovered, backgroundColor: backgroundColor, borderColor: borderColor })();
    return (React.createElement(MaterialPaper, __assign({ ref: ref, classes: styles }, props), children));
});
//# sourceMappingURL=Paper.js.map